import { useDraggable } from '@dnd-kit/core'
import { uniqueId } from 'lodash'
import { useEffect, useRef } from 'react'
import { Transform } from 'types'
import { Mover } from './style'

type Props = {
    className?: string
    onDragStateChange?: (dragging: boolean) => void
    onMove: (transform: Transform) => void
}

const DraggableMover = ({ className, onDragStateChange, onMove }: Props) => {
    const idRef = useRef<string>(uniqueId('crop-mover'))
    const { attributes, isDragging, listeners, setNodeRef, transform } = useDraggable({
        id: idRef.current,
        data: { control: 'crop', controlId: idRef.current, controlType: 'crop-move' },
    })

    useEffect(() => {
        onDragStateChange?.(isDragging)
    }, [isDragging])

    useEffect(() => {
        if (transform) {
            const { x, y } = transform
            onMove({ rotation: 0, scaleX: 1, scaleY: 1, x, y })
        }
    }, [transform?.x, transform?.y])

    return <Mover {...listeners} {...attributes} className={className} ref={setNodeRef} />
}

export default DraggableMover
